import { getWindow } from "@faire/web--source/common/getWindow";
import { BAIT_IDS } from "./consts";
import { isElementVisible } from "./isElementVisible";
export var doesUserHaveAdblock = function() {
    return !BAIT_IDS.map(function(id) {
        return getWindow().document.getElementById(id);
    }).every(isElementVisible);
};
